<template>
  <div class="editor-dashboard-sec-2 approval-list-sec draft-order-sec">
    <div class="table-responsive">
      <table class="addon-table draft-orders-table">
        <colgroup>
          <col v-if="enableMultiSelect" class="col-select" />
          <col class="col-id" />
          <col class="col-order-title" />
          <col class="col-plan-submitted" />
          <col class="col-created-by" />
          <col class="col-updated-by" />
          <col class="col-approved-by" />
          <col class="col-updated-at" />
          <col class="col-total" />
          <col class="col-total-links" />
          <col class="col-type" />
          <col class="col-date-created" />
          <col class="col-actions" />
        </colgroup>
        <tr>
          <th v-if="enableMultiSelect" class="col-select">
            <input
              type="checkbox"
              :checked="allVisibleSelected"
              :indeterminate.prop="someVisibleSelected && !allVisibleSelected"
              @change="toggleSelectAllVisible"
              aria-label="Select all draft orders"
            />
          </th>
          <th>Id</th>
          <th v-if="dashboardDraft" class="col-order-title">Order Title</th>
          <th v-else class="col-order-title" @click="sortByColumn('order_title')">
            Order Title 
            <span><i class="fas fa-sort"></i></span>
          </th>
          <th class="col-plan-submitted">Plan Submitted For</th>
          <th class="col-created-by">Created By</th>
          <th class="col-updated-by">Updated By</th>
          <th class="col-approved-by">Approved By</th>
          <th class="col-updated-at">Updated At</th>
          <th class="col-total">Total</th>
          <th class="col-total-links">Total Links</th>
          <th class="col-type">Type</th>
          <th v-if="dashboardDraft" class="col-date-created">Date Created</th>
          <th v-else class="col-date-created" @click="sortByColumn('created_at')">
            Date Created  
            <span><i class="fas fa-sort"></i></span>
          </th>
          <th class="col-actions">Actions</th>
        </tr>
        <tr v-for="draftRow in draft_orders" :key="draftRow.id" :class="{ draftApproved: draftRow.approved_at }">
          <td v-if="enableMultiSelect" class="col-select">
            <input
              type="checkbox"
              :value="draftRow.id"
              :checked="isDraftSelected(draftRow.id)"
              @change="toggleDraftSelection(draftRow.id)"
              :aria-label="'Select draft order ' + draftRow.id"
            />
          </td>
          <td>{{ draftRow.id }}</td>
          <td class="col-order-title">{{ draftRow.order_title }}</td>
          <td class="col-plan-submitted">{{ draftRow.user_id }}</td>
          <td class="col-created-by">{{ draftRow.created_by }}</td>
          <td class="col-updated-by">{{ draftRow.updated_by }}</td>
          <td class="col-approved-by">{{ draftRow.approved_by }}</td>
          <td class="col-updated-at">{{ draftRow.updated_at }}</td>
          <td class="col-total">{{ numberFormat(draftRow.amount,'currency') }}</td>
          <td class="col-total-links">{{ getDraftLinksCount(draftRow) }}</td>
          <td class="col-type">{{ draftRow.order_status == 'pending' ? 'new plan' : draftRow.order_status }}</td>
          <td class="col-date-created">{{ draftRow.date }}</td>
          <td class="action-btns">
            <div class="btn-group">
              <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                ...
              </button>

              <ul class="dropdown-menu" role="menu">
                <li>
                  <router-link 
                    :to="
                      draftRow.order_type == 'normal'
                        ? { path: `/product/${draftRow.id}`, query: $route.query }
                        : draftRow.order_type == 'media_placement'
                          ? { path: `/media-links-summary/${draftRow.id}`, query: $route.query }
                          : { path: `/missed-opportunity-order/${draftRow.id}`, query: $route.query }
                    "
                    @click="onReviewOrderClick"
                    class="proceed-text"
                    >Review Order
                  </router-link>
                </li>
                <li><a href="javascript:;" v-b-modal.modal-box-4 @click="currentDraft(draftRow.id)">Mark Approved</a></li>
                <li><a href="javascript:;" @click="deleteButtonPopupDraft(draftRow.id)">Remove Order</a></li>
              </ul>

            </div>
          </td>
        </tr>
      </table>
      <p class="article-text" v-if="draftOrdersLength == false">
        You Have No Orders In Draft.
      </p>
      <draftModals @approvedDraft="approvedDraft"></draftModals>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import draftModals from "@/components/orderLinksComponents/AllModals.vue";
import { numberFormat } from '@/prod.js';
import url from "@/prod.js";
import { getDraftLinksCount } from "@/utils/draftOrderListHelpers.js";
import swal from "sweetalert2";
const toast = useToast();
import jquery from "jquery";
export default {
  props: {
    draft_orders: Array,
    dashboardDraft: Boolean,
    enableMultiSelect: {
      type: Boolean,
      default: false,
    },
    selectedDraftIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:selectedDraftIds'],
  components: {
    draftModals,
  },
  data() {
    return {
      numberFormat,
      getDraftLinksCount,
      loading: false,
      currentLink: '',
      order: 'desc',
      appStatus: url.appStatus,
    };
  },
  methods: {
    trackDraftActionEvent(eventName, extraParams = {}) {
      if (this.appStatus !== "production") return;
      if (typeof window === "undefined") return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...extraParams,
      });
    },
    onReviewOrderClick() {
      this.trackDraftActionEvent("review_order", {
        order_stage: "review",
      });
    },
    async currentDraft(id) {
      this.currentLink = id;
    },
    async deleteDraft(delete_id) {
      this.loading = true;
      try {
        let res = await this.$store.dispatch("Product/deleteDraftOrderAction",
          { 'id': delete_id },
          {
            root: true,
          });
        if (res.success) {
          this.$parent.getDraftOrder();
          this.loading = false;
          toast.success(res.message, { timeout: 3000 }, window.location.reload());
        }
      } catch (error) {
        this.loading = false;
        this.errors = error.response.data.errors;
        this.$router.push("/dashboard");
      }
    },

    async approvedDraft(approvedAt) {
      this.trackDraftActionEvent("mark_approved", {
        approval_status: "approved",
      });
      this.$parent.loading = true;
      try {
        let res = await this.$store.dispatch("Product/approvedDraftOrderAction", {
          id: this.currentLink,
          approved_at: approvedAt
        },
          {
            root: true,
          });
        if (res.success) {
          this.$parent.getDraftOrder();
          jquery(".btn-close").trigger("click");
          this.$parent.loading = false;
          toast.success(res.message, { timeout: 3000 });
        }
      } catch (error) {
        this.$parent.loading = false;
        this.errors = error;
      }
    },

    async deleteButtonPopupDraft(id) {
      swal.fire({
        title: 'Are you sure?',
        text: "On click delete your draft will be removed from the list!",
        icon: 'warning',
        width: 600,
        showCancelButton: true,
        confirmButtonColor: '#00b6cb',
        cancelButtonColor: '#ff0e52',
        confirmButtonText: 'Delete'
      }).then((result) => {
        if (result.isConfirmed) {
          this.trackDraftActionEvent("remove_order", {
            action_type: "removed",
          });
          this.deleteDraft(id);
        }
      });
      },
      sortByColumn(column) {
        this.order = (this.order == 'asc') ? 'desc' : 'asc';
        this.$parent.getSortedResults(column,this.order);
      },
    isDraftSelected(id) {
      return (this.selectedDraftIds || []).includes(Number(id));
    },
    toggleDraftSelection(id) {
      const draftId = Number(id);
      const current = Array.isArray(this.selectedDraftIds) ? [...this.selectedDraftIds] : [];
      const index = current.indexOf(draftId);
      if (index === -1) {
        current.push(draftId);
      } else {
        current.splice(index, 1);
      }
      this.$emit('update:selectedDraftIds', current);
    },
    toggleSelectAllVisible() {
      const visibleIds = (this.draft_orders || []).map((row) => Number(row.id));
      const current = Array.isArray(this.selectedDraftIds) ? [...this.selectedDraftIds] : [];
      const allSelected = visibleIds.length > 0 && visibleIds.every((id) => current.includes(id));

      if (allSelected) {
        this.$emit(
          'update:selectedDraftIds',
          current.filter((id) => !visibleIds.includes(id))
        );
        return;
      }

      const merged = [...current];
      visibleIds.forEach((id) => {
        if (!merged.includes(id)) {
          merged.push(id);
        }
      });
      this.$emit('update:selectedDraftIds', merged);
    },
  },
  computed: {
    draftOrdersLength() {
      return (this.draft_orders || []).length > 0;
    },
    visibleDraftIds() {
      return (this.draft_orders || []).map((row) => Number(row.id));
    },
    allVisibleSelected() {
      const ids = this.visibleDraftIds;
      if (!ids.length) return false;
      return ids.every((id) => (this.selectedDraftIds || []).includes(id));
    },
    someVisibleSelected() {
      return this.visibleDraftIds.some((id) => (this.selectedDraftIds || []).includes(id));
    },
  }
};
</script>
